export default __webpack_public_path__ + "static/gearsOfWarOmen-e15f9b3805c7470d1c6974da570c8ce7.svg";